import { parse } from '@config/theme';
export const buttonContainer = parse({
  position: 'fixed'
}, "b1x2rjsx");

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");